import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Card, Grid } from '@mui/material';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import DataTable from 'examples/Tables/DataTable';

import {
  getAllFAQsList,
  resetAllFAQs,
  updateFAQOrder,
} from 'store/reducers/faqsSlice';

const ReorderFAQs = () => {
  const dispatch = useDispatch();
  const { allFaqsList } = useSelector((state) => state.faqs);

  const [isLoading, setLoading] = useState(false);

  const columns = [
    {
      Header: 'ID',
      accessor: 'id',
      align: 'left',
    },
    {
      Header: 'Questions',
      accessor: 'question',
      align: 'left',
      disableFilters: true,
      disableSortBy: true,
    },
    {
      Header: 'Priority',
      accessor: 'priorityIndex',
      align: 'left',
      disableFilters: true,
      disableSortBy: true,
    },
  ];

  const rows =
    allFaqsList?.length > 0
      ? allFaqsList?.map((faq) => {
          return {
            id: faq?.id,
            question: (
              <div style={{ maxWidth: '50ch' }}>{faq?.question ?? 'NA'}</div>
            ),
            priorityIndex: faq?.priorityIndex,
          };
        })
      : [];

  async function fetchFAQsList() {
    try {
      setLoading(true);
      await dispatch(getAllFAQsList());
    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false);
    }
  }

  const onDragEnd = async (faqId, newPriority, sourceIndex) => {
    try {
      await dispatch(
        updateFAQOrder({
          faqId,
          newPriority: newPriority + 1,
        })
      );
      fetchFAQsList();
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    fetchFAQsList();

    return () => {
      dispatch(resetAllFAQs());
    };
  }, []);

  return (
    <MDBox pt={6} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Re-order Frequently Asked Questions
              </MDTypography>
            </MDBox>
            <MDBox mt={3}>
              <DataTable
                table={{
                  columns,
                  rows,
                }}
                isSorted={false}
                entriesPerPage={false}
                showTotalEntries={false}
                canSearch={false}
                hiddenColumns={['id']}
                isLoading={isLoading}
                isDraggable
                onDragRow={onDragEnd}
              />
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default ReorderFAQs;
